import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    updateChannel = new Subject();
    detailChannel = new Subject();
    repository = new UpdateRepository()
    educationChannel = new Subject()
    rumpunChannel = new Subject();
   
    constructor() {
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.educationChannel.next({status: apiResponse.INITIAL})
        this.rumpunChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchUpdate = async (query) => {
        try {
            this.updateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.updateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchEducation = async (query) => {
        try {
            this.educationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducation(query).then((result) => {
                this.educationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchRumpun = async (query) => {
        try {
            this.rumpunChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchRumpun(query).then((result) => {
                this.rumpunChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rumpunChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }
}

export default UpdateBloc